import { render, staticRenderFns } from "./WorkOrderCreateForStock.vue?vue&type=template&id=bc3dfe4c&scoped=true&"
import script from "./WorkOrderCreateForStock.vue?vue&type=script&lang=js&"
export * from "./WorkOrderCreateForStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3dfe4c",
  null
  
)

export default component.exports